import script from "./SaaSHostingLayout.vue?vue&type=script&setup=true&lang=js"
export * from "./SaaSHostingLayout.vue?vue&type=script&setup=true&lang=js"

import "./SaaSHostingLayout.vue?vue&type=style&index=0&id=27d75886&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-27d75886"]])

export default __exports__